import { PLANS, type PlanId } from "./plans";

/**
 * Bildrensning styrs av ett månadstak (nollställs när abonnemangsperioden
 * förnyas) och ett dygnstak som spärr mot att hela kvoten bränns på en kväll.
 */
export const CLEAN_IMAGE_MONTHLY_LIMIT: Record<PlanId, number> = {
  free: PLANS.free.limits.cleanImagesPerMonth,
  plus: PLANS.plus.limits.cleanImagesPerMonth,
  pro: PLANS.pro.limits.cleanImagesPerMonth,
  expert: PLANS.expert.limits.cleanImagesPerMonth,
};

/** Dygnsspärren per plan. */
export const CLEAN_IMAGE_DAILY_LIMIT: Record<PlanId, number> = {
  free: PLANS.free.limits.cleanImagesPerDay,
  plus: PLANS.plus.limits.cleanImagesPerDay,
  pro: PLANS.pro.limits.cleanImagesPerDay,
  expert: PLANS.expert.limits.cleanImagesPerDay,
};

/** Hur många AI-varianter man får skapa av exakt samma bild. */
export const CLEAN_IMAGE_MAX_VARIANTS = 2;

export type CleanImageQuota = {
  plan: PlanId;
  /** Månadstaket – det som styr. */
  limit: number;
  used: number;
  remaining: number;
  /** Dygnsspärren. */
  dayLimit: number;
  dayUsed: number;
  dayRemaining: number;
  unlimited: boolean;
  maxVariants: number;
  /** Så många AI-bilder som är kvar i gratisprovet (0 när provet inte gäller). */
  trialLeft?: number;
};

/** Vad AI:n läste av i bilden innan bildstudion redigerar den. */
export type StudioSubject = {
  /** Kort engelsk beskrivning – används i prompten till bildmodellen. */
  subject: string;
  /** Kort svensk beskrivning – visas för användaren. */
  subjectSv: string;
  /** Störande föremål som inte ska följa med. */
  distractors: string[];
  /** Prylens ruta i andelar 0–1, null när AI:n inte kunde avgöra. */
  box: { x: number; y: number; w: number; h: number } | null;
};
